import { render } from "./MergeTicketsModal.vue?vue&type=template&id=70bf605d"
import script from "./MergeTicketsModal.vue?vue&type=script&lang=js"
export * from "./MergeTicketsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__